// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LoadingSwitch":"bhe_a bht_ea bht_a","LoadingSwitch__init":"bhe_b bht_a bht_w bht_j bht_ul bht_um bht_fm"};